import { render } from "./categoryTutorials.vue?vue&type=template&id=3e7c9bb9"
import script from "./categoryTutorials.vue?vue&type=script&lang=js"
export * from "./categoryTutorials.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__